module.exports = "/_next/static/images/game-1-phone-gallery-08-27-1730-uv-4bbbcf0adabefa4b0b6dbf90829cccf1.jpg";